export default "__VITE_ASSET__3449adb8__"